import { Pipe, PipeTransform } from '@angular/core';

const emptyText = '---';

@Pipe({
    name: 'empty',
    standalone: true
})
export class EmptyPipe implements PipeTransform {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform(value: any): string {
    return value ? value : emptyText;
  }
}
